<template>
  <div class="title-text">{{ $l('title_text_fabric_info') || '面料信息' }}</div>
</template>

<script>
export default {}
</script>
<style lang="scss" scoped>
.title-text {
  height: 23px;
  line-height: 23px;
  color: #303133;
  font-size: 16px;
  font-weight: 600;
}
</style>
